import { Zap } from "lucide-react";

/**
 * QuotaBadge — displays remaining generations for the shared community pool.
 * Fully anonymous, no auth, no PII.
 */
export const QuotaBadge = ({ quota, lang = "fr" }) => {
  if (!quota) return null;
  const { remaining, daily_limit } = quota;
  const empty = remaining <= 0;
  const bg = empty ? "#FFDAC1" : remaining <= 3 ? "#FFF2B2" : "#B5EAD7";
  const label =
    lang === "fr"
      ? empty
        ? "Quota du jour atteint"
        : `${remaining}/${daily_limit} restantes`
      : empty
        ? "Daily quota reached"
        : `${remaining}/${daily_limit} left`;
  const title =
    lang === "fr"
      ? "Quota partagé par la communauté, réinitialisation à minuit UTC"
      : "Shared community quota, resets at UTC midnight";
  return (
    <span
      data-testid="quota-badge"
      className="hidden sm:inline-flex items-center gap-1.5 border-2 border-black rounded-full px-3 py-1 text-xs font-bold nb-shadow-sm"
      style={{ background: bg }}
      title={title}
    >
      <Zap className="w-3 h-3" />
      {label}
    </span>
  );
};
